export const HOME_URL = '/v2/chooseCmp'
